import React, { useState, useEffect } from "react";
import { resetPasswordWithToken } from "@quintype/bridgekeeper-js";

import { InputField } from "../../atoms/InputField";
import { translateError } from "../../utils";
import Button from "../../atoms/Button";
import "./reset-password.m.css";
import { AppLogo } from "../../layouts/app-logo";

const ResetPasswordPage = () => {
  const [user, setUser] = useState({
    newPassword: "",
    confirmPassword: ""
  });
  const [error, setError] = useState(null);
  const [token, setToken] = useState(null); // Store the token which is received in the query params
  const [message, setMessage] = useState(null);
  useEffect(() => {
    // To be called only once during the first load
    const urlParams = new URLSearchParams(window.location.search);
    const queryToken = urlParams.get("token") || "";

    if (queryToken) {
      // Set the state if both exists
      setToken(queryToken);
    } else {
      setError("Jotain meni pieleen... Ole hyvä ja kokeile uudelleen.");
    }
  }, []);

  const setData = e => {
    const userObj = { ...user };
    const id = e.target.id;
    userObj[id] = e.target.value;
    setUser(userObj);
  };

  const resetPasswordHandler = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (user.newPassword !== user.confirmPassword) {
      setError("Salasanat eivät täsmää!");
      return;
    }
    if (!user.newPassword || !user.confirmPassword) {
      setError("Salasana ei voi olla tyhjä!");
      return;
    }
    const reqObj = {
      "new-password": user.newPassword,
      "confirm-password": user.confirmPassword,
      token
    };
    const { error } = await resetPasswordWithToken(reqObj);
    if (error) {
      setError(translateError(error.message));
      return;
    }

    // need to open successful popup
    setMessage("Salasana on päivitetty. Käytä uutta salasanaa seuraavalla kirjautumiskerralla.");
    setTimeout(() => {
      setMessage(null);
      window.location.href = "/";
    }, 5000);
  };
  return (
    <div styleName="user-login-wrapper">
      <div styleName="wrapper">
        <div styleName="header">
          <AppLogo width="140" />
        </div>
        <div styleName="form" key="reset-password">
          <ul>
            <li styleName="custom-box-title">
              LUO UUSI SALASANA
            </li>
          </ul>
          <div styleName="content-text">
            Luo uusi turvallinen salasanasi Dei Plus -palveluun. Hyvä salasana sisältää isojen ja pienien kirjaimien lisäksi myös numeroita ja erikoismerkkejä.
          </div>
          <InputField
            name="Uusi salasana"
            id="newPassword"
            type="password"
            value={user.newPassword}
            onChange={setData}
            required
            styleName="password"
          />
          <InputField
            name="Vahvista salasana"
            id="confirmPassword"
            type="password"
            value={user.confirmPassword}
            onChange={setData}
            required
            styleName="password"
          />
          {error && <span styleName="error">{error}</span>}
          <span onClick={e => resetPasswordHandler(e)}>
            <button styleName="reset-password-btn" aria-label="button">
              Vaihda salasana
            </button>
          </span>
          {message && <span styleName="success">{message}</span>}
        </div>
      </div>
    </div>
  );
};

export { ResetPasswordPage };
